import React from "react"
import { ExternalLink } from "components"

import styles from "./hotel.module.scss"

const Hotel = ({ content }) => (
  <div className={styles.hotel}>
    <ExternalLink className={styles.name} url={content.url}>
      {content.name}
    </ExternalLink>
    <address className={styles.address}>
      <p>{content.address}</p>
      <p>Tel. {content.phone}</p>
    </address>
  </div>
)

export default Hotel
